<template>
  <div>
    <div id="Area"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "Area",
  data() {
    return {
      colorList: ['rgba(89,89,215,1)', 'rgba(192,196,204,1)', 'rgb(65,228,222)', 'rgb(50,184,240)'],
      colorList2: ['rgba(89,89,215,.6)', 'rgba(192,196,204,.6)', 'rgba(65,228,222,.6)', 'rgba(50,184,240,.6)'],
      AreaCharts: null,
      options: {
        tooltip: {
          trigger: 'item',
        },
        graphic: {
          type: 'text',
          left: '45%',
          top: '35%',
          style: {
            text: null,
            fill: '#fff',
            font: '.9rem "STHeiti", sans-serif',
          }
        },
        title: { // 第一个圆环标题
          text: "片区响应", // 主标题
          textStyle: { // 主标题样式
            color: '#BCCBEF',
            fontSize: '.7rem',
            fontWeight: '500',
          },
          left: '45%',
          top: '45%', // 定位到适合的位置
          subtext: '（个）', // 副标题
          subtextStyle: { // 副标题样式
            color: '#287CE8',
            fontSize: '.6rem',
            fontWeight: '500',
            lineHeight: 5,
          },
          textAlign: 'center'
        },
        series: [
          {
            name: '片区',
            type: 'pie',
            radius: ['80%', '90%'],
            emphasis: {
              scale: false,
            },
            label: {
              show: false,
            },
            minAngle: 30,//最小角度
            avoidLabelOverlap: false,
            data: []
          }, {
            name: '片区',
            type: 'pie',
            minAngle: 30,//最小角度
            radius: ['60%', '83%'],
            emphasis: {
              scale: false,
            },
            label: {
              show: false
            },
            avoidLabelOverlap: false,
            data: [],
            itemStyle: {
              color: 'rgba(89,89,215,.6)',
            }
          }
        ]
      }
    }
  },
  mounted() {
    this.getAreaPercentage()
  },
  methods: {
    initCharts() {
      let AreaCharts = document.getElementById('Area');
      this.AreaCharts = echarts.init(AreaCharts);
      this.AreaCharts.setOption(this.options);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          this.AreaCharts.resize();
        });
      });
    },
    getAreaPercentage() {
      this.$http.get(`/api/getRegionalResponseNumber`).then(res => {
          if (res.status === 200) {
            this.options.series[0].data = [res.data]
            this.options.series[1].data = [res.data]
            this.options.graphic.style.text = res.data
            this.$nextTick(() => {
              this.initCharts()
            })
          }
        }
      )
    },
  }
}
</script>

<style scoped lang="less">
#Area {
  width: 100%;
  height: 12vh;
  margin-top: 10px;
}
</style>
